import { MasterButton } from "App/Component/ui";
import { instance4 } from "App/constants";
import { oneMonthBeforeToday } from "App/utils/helpers";
import moment from "moment";
import {
  STATUS_PENGERJAAN_DRAFT,
  STATUS_PENGERJAAN_PENGAJUAN,
  STATUS_PENGERJAAN_DISETUJUI,
  STATUS_PENGERJAAN_PENDING,
  STATUS_PENGERJAAN_PROSES,
  STATUS_PENGERJAAN_SELESAI,
  STATUS_PENGERJAAN_REVISI,
  STATUS_PENGERJAAN_REJECT,
} from "../HelpDesk/helpers";
import React from "react";
import { lastOfDay, startOfDay } from "utils/dates";

export const urlGet = "/wmsAsset/maintance/list";
export const urlDelete = "/wmsAsset/maintance/delete-header";

export const RESET_STATE_FORM_FILTER = {
  pages: 1,
  limit: 10,
  id: "",
  id_helpdesk_header: "",
  is_vendor:"",
  vendor_id:"",
  nama_vendor:"Pilih Vendor",
  pic:"",
  unit_id: null,
  unit: "Pilih Unit",
  gudang_id: null,
  gudang: "Pilih Unit",
  status_service: null,
  nama_status_service: "Pilih Status",
  tglAwal: oneMonthBeforeToday(),
  tglAkhir: moment(new Date()).local().toDate(),
};

export const getByFilter = async (
  formFilter,
  pages,
  limit,
  alwaysPengadaan = false
) => {
  try {
    const api = await instance4.post(urlGet, {
      halaman: pages,
      jumlah: limit,
      id: formFilter.id,
      id_helpdesk_header: formFilter.id_helpdesk_header,
      is_vendor: formFilter.is_vendor,
      vendor_id: formFilter.vendor_id,
      pic: formFilter.pic,
      unit_id: formFilter.unit_id,
      gudang_id: formFilter.gudang_id,
      status_service: formFilter.status_service,
      tglAwal: startOfDay(formFilter.tglAwal),
      tglAkhir: lastOfDay(formFilter.tglAkhir),
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deleteById = async (id) => {
  try {
    const api = await instance4.post(urlDelete, { id }, {});
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus data",
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      data: {},
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    minWidth: "80px",
  },
  {
    id: "unit",
    disablePadding: false,
    label: "UNIT",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "gudang",
    disablePadding: false,
    label: "GUDANG",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "id_helpdesk_header",
    disablePadding: false,
    label: "ID HELP DESK",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "CATATAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "user_request",
    disablePadding: false,
    label: "USERNAME REQUEST",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "vendor",
    disablePadding: false,
    label: "VENDOR",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "pic",
    disablePadding: false,
    label: "PIC",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "status_service",
    disablePadding: false,
    label: "STATUS SERVICE",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "tanggal_service",
    disablePadding: false,
    label: "TGL SERVICE",
    align: "left",
    minWidth: "160px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const RenderStatusVerifikasiBadge = ({ status }) => {
  if (status === STATUS_PENGERJAAN_DRAFT) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"DRAFT"}
        color={"secondary"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_PENGERJAAN_PENGAJUAN) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"PENGAJUAN"}
        color={"warning"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_PENGERJAAN_DISETUJUI) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"DISETUJUI"}
        color={"lightgreen"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_PENGERJAAN_PENDING) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"PENDING"}
        color={"warning"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_PENGERJAAN_PROSES) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"PROSES"}
        color={"green"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_PENGERJAAN_SELESAI) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"SELESAI"}
        color={"green"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_PENGERJAAN_REVISI) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"REVISI"}
        color={"warning"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_PENGERJAAN_REJECT) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"DITOLAK"}
        color={"danger"}
        type="button"
        disabled
      />
    );
  } else {
    return <p>-</p>;
  }
};

